import _request from '@/utils/request.js'

var _pointsPlan = {
  // 折算业绩与提成方案列表
  queryPointsPlanList (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/query/points/plan/list"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 折算业绩与提成方案详情
  pointsPlanDetalis (id, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/royalty/asset/details"),
      params: {
        id: id
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 新增&修改
  pointsPlanAddOrEdit (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/asset/addOrEdit"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  }
}

export default _pointsPlan